define.alias("shared/modifiers/autofocus", "settings/modifiers/autofocus");